import { useEffect, useState } from 'react';
import { PhotoType } from '../../../../types/models';
import { apiStringerPhotosGet } from '../../../../actions/photoActions';
import { CLOUDFRONT_URL } from '../../../../core/common';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import './StringerPhotos.scss';
import { StringerPhoto } from './StringerPhoto';
import { useSelector } from 'react-redux';

const elementsOnPage = 49;

const CancelToken = axios.CancelToken;
let source: any;

interface StringerPhotosProps {
  userId?: number;
}

export const StringerPhotos = ({ userId }: StringerPhotosProps) => {
  const [photos, setPhotos] = useState<PhotoType[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const token = useSelector(state => state.user.token);

  useEffect(() => {
    getPhotos();
  }, [page]);

  const getPhotos = async () => {
    if (source) {
      source.cancel();
    }

    source = CancelToken.source();

    setLoading(true);
    try {
      const data = await apiStringerPhotosGet({
        accessToken: token,
        limit: elementsOnPage,
        offset: page * elementsOnPage,
        cancelToken: source.token,
      });
      setPhotos(data.photos);
      setCount(data.count);
    } catch (error) {
      console.error('Error fetching photos:', error);
    } finally {
      setLoading(false);
    }
  };

  const pagination = (
    <div className="table-page-paginations">
      <ReactPaginate
        forcePage={page}
        breakLabel="..."
        nextLabel=">"
        onPageChange={event => {
          setPage(event.selected);
        }}
        pageRangeDisplayed={3}
        pageCount={Math.ceil(count / elementsOnPage)}
        previousLabel="<"
      />
    </div>
  );

  return (
    <div className="stringer-photos">
      {loading ? (
        <div className="stringer-photos-loader">
          <div className="lds-ripple">
            <div />
            <div />
          </div>
        </div>
      ) : photos.length > 0 ? (
        <>
          <div className="stringer-photos-content">
            <div className="stringer-photos-grid">
              {photos.map((photo, index) => (
                <StringerPhoto
                  key={photo.id}
                  src={`${CLOUDFRONT_URL}${photo.thumbnail_path}`}
                  title={photo.filename}
                  album={photo.album}
                  onPhotoClick={() => {
                    setSelectedIndex(index);
                    setIsLightboxOpen(true);
                  }}
                />
              ))}
            </div>
            <div style={{ marginTop: '20px' }}>{count > elementsOnPage && pagination}</div>
          </div>
        </>
      ) : (
        <div className="stringer-photos-empty">
          <p>Photos not found</p>
        </div>
      )}
      <Lightbox
        open={isLightboxOpen}
        close={() => setIsLightboxOpen(false)}
        index={selectedIndex}
        slides={photos.map(photo => ({
          src: `${CLOUDFRONT_URL}${photo.path}`,
          title: photo.filename,
        }))}
        carousel={{
          finite: true,
          preload: 2,
        }}
        animation={{
          fade: 300,
          swipe: 500,
        }}
        controller={{
          closeOnBackdropClick: true,
          closeOnPullDown: true,
        }}
      />
    </div>
  );
};
